import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      La mola stano akiras firmecon en kuniĝo kun eĉ pli mola grafito. Ĉar kiam apude estas iu pli malforta…
      </p>
    
    <p class="mb-3">
      Ofte la forton naskas malforto. Malforto, kiu naskas deziron protekti.
      </p>
    
    <p class="mb-3">
      Eble, ĝuste de tio komenciĝis la historio de nia planedo.
    </p>
    `
  )
}

const itemName = {
  esp: 'La naskiĝo de la forto'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;